<template>
  <div v-if="isLoading" class="w-full h-full my-20 flex flex-col justify-center items-center">
    <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
      <path d="M 100 51 C 100 78 78 101 50 101 C 22 101 0 78 0 51 C 0 23 22 1 50 1 C 78 1 100 23 100 51 Z M 9 51 C 9 73 27 92 50 92 C 73 92 91 73 91 51 C 91 28 73 10 50 10 C 27 10 9 28 9 51 Z" fill="currentColor" />
      <path d="M 94 39 C 96.4 38.4 97.9 35.9 97 33.6 C 95.3 28.8 92.9 24.4 89.8 20.3 C 85.8 15.1 80.9 10.7 75.2 7.4 C 69.5 4.1 63.3 1.9 56.8 1.1 C 51.8 0.4 46.7 0.4 41.7 1.3 C 39.3 1.7 37.8 4.2 38.5 6.6 C 39.1 9 41.6 10.5 44.1 10.1 C 47.9 9.5 51.7 9.5 55.5 10 C 60.9 10.8 66 12.5 70.6 15.3 C 75.3 18 79.3 21.6 82.6 25.8 C 84.9 28.9 86.8 32.3 88.2 35.9 C 89.1 38.2 91.5 39.7 94 39 Z" fill="currentFill" />
    </svg>
    <span class="mt-4 animate-bounce">Ładowanie godzin otwarcia</span>
  </div>
  <div v-else class="relative bg-zt-light/35 rounded-zt pt-6 my-2 flex flex-col gap-2
       pb-2.5 -mx-4 px-1 xl:pb-3.5 xl:mx-0 xl:pl-3.5 xl:pr-6">
    <span class="text-xl font-semibold mb-1 px-1 xl:px-0">{{ bookiesData.bookies_hours_title }}</span>
    <template v-for="item in bookiesData.bookies_hours_data" :key="item.bookie_hours_name">
      <div v-if="item.bookie_hours_data || item.is_bookie_closed" :id="'accordion-' + item.bookie_hours_name"
           class="flex border border-zt-light rounded-zt">
        <div class="bg-zt-light rounded-zt flex justify-center items-center py-3 w-[84px] xl:w-[224px]">
          <span class="font-semibold truncate px-2 text-sm xl:text-xl">{{ item.bookie_hours_name }}</span>
        </div>
        <div class="bg-zt-light/35 flex-1 flex flex-col justify-center items-center">
          <div class="relative w-full min-h-[55px] flex justify-center items-center px-[42.5px] py-2"
               :class="{ 'cursor-pointer zt-hover': !item.is_bookie_closed && item.bookie_hours_data.length > 1 }"
               @click="toggleAccordion(item)"
               data-bs-toggle="collapse" :data-bs-target="!item.is_bookie_closed && '#collapse-' + item.bookie_hours_name"
               :aria-controls="'collapse-' + item.bookie_hours_name">
            <span v-if="item.is_bookie_closed" class="text-zt-more font-medium text-sm xl:text-base">Zamknięte</span>
            <span v-else class="font-medium text-center text-sm xl:text-base">{{ item.bookie_hours_data[0].bookie_hour_data }}</span>
            <template v-if="!item.is_bookie_closed && item.bookie_hours_data.length > 1">
              <svg v-if="window.size.desktop"
                   class="absolute right-3 top-1/2 -translate-y-1/2 transition-transform"
                   :class="{ 'rotate-180': item.isAccordionOpen }"
                   width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M 11 11.7 L 20.8 1.7 C 20.9 1.5 21 1.2 21 1 C 21 0.7 20.9 0.5 20.7 0.3 C 20.5 0.1 20.3 0 20 0 C 19.8 -0 19.6 0.1 19.4 0.2 L 10.4 9.5 L 1.7 0.5 C 1.5 0.3 1.3 0.2 1 0.2 C 0.7 0.2 0.5 0.3 0.3 0.5 C 0.2 0.6 0.1 0.7 0.1 0.8 C 0 1 0 1.1 0 1.2 C 0 1.4 0 1.5 0.1 1.6 C 0.1 1.7 0.2 1.9 0.3 2 L 9.8 11.7 C 10 11.9 10.2 12 10.4 12 C 10.6 12 10.8 11.9 11 11.7 Z" fill="white" />
              </svg>
              <svg v-else
                   class="absolute right-3 top-1/2 -translate-y-1/2 transition-transform"
                   :class="{ 'rotate-180': item.isAccordionOpen }"
                   width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M 7.3 7.8 L 13.8 1.1 C 13.9 1 14 0.8 14 0.7 C 14 0.5 13.9 0.3 13.8 0.2 C 13.7 0.1 13.5 0 13.4 0 C 13.2 -0 13 0.1 12.9 0.2 L 6.9 6.3 L 1.1 0.3 C 1 0.2 0.8 0.1 0.7 0.1 C 0.5 0.1 0.3 0.2 0.2 0.3 C 0.1 0.4 0.1 0.5 0.1 0.6 C 0 0.6 0 0.7 0 0.8 C 0 0.9 0 1 0.1 1.1 C 0.1 1.2 0.1 1.2 0.2 1.3 L 6.5 7.8 C 6.6 7.9 6.8 8 6.9 8 C 7.1 8 7.2 7.9 7.3 7.8 Z" fill="white"/>
              </svg>
            </template>
          </div>
          <div :id="'collapse-' + item.bookie_hours_name" class="accordion-collapse w-full collapse flex flex-col"
               :data-bs-parent="'#accordion-' + item.bookie_hours_name">
            <template v-for="(hoursItem, index) in item.bookie_hours_data">
              <template v-if="index !== 0">
                <hr class="border border-t border-zt-light/60" />
                <div class="w-full py-2 px-[42.5px] flex justify-center items-center">
                  <span class="font-medium text-center text-sm xl:text-base">{{ hoursItem.bookie_hour_data }}</span>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
    <div class="absolute w-[238px] h-1.5 top-0 left-1/2 -translate-x-1/2 rounded-b bg-zt-red"></div>
  </div>
</template>

<script>
export default {
  name: 'OpeningHours',
  inject: ['WP'],
  data() {
    return {
      bookiesData: [],
      isLoading: true
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios.get('/wp-json/acf/v3/posts/' + WP.id + '?_fields=acf.bookies_hours_info&acf_format=standard')
      .then(response => {
        this.bookiesData = {
          bookies_hours_title: response.data.acf.bookies_hours_info.bookies_hours_title,
          bookies_hours_data: response.data.acf.bookies_hours_info.bookies_hours_data.map(item => ({
            ...item,
            isAccordionOpen: false
          }))
        };
        this.isLoading = false;
      });
    },
    toggleAccordion(item) {
      item.isAccordionOpen = !item.isAccordionOpen;
    }
  }
};
</script>